import api from "../../../api/axios";

const BASE_URL = "/api/v1/power/excel-fill";

const buildExcelFillFormData = ({
  schoolYearId,
  file,
  sheetName,
  headerRow,
  firstNameColumn,
  lastNameColumn,
  startDateColumn,
}) => {
  const formData = new FormData();

  formData.append("school_year", schoolYearId);
  formData.append("file", file);

  if (sheetName) {
    formData.append("sheetName", sheetName);
  }

  if (headerRow) {
    formData.append("headerRow", headerRow);
  }

  if (firstNameColumn) {
    formData.append("firstNameColumn", firstNameColumn);
  }

  if (lastNameColumn) {
    formData.append("lastNameColumn", lastNameColumn);
  }

  if (startDateColumn) {
    formData.append("startDateColumn", startDateColumn);
  }

  return formData;
};

const previewExcelFill = async ({
  schoolYearId,
  file,
  sheetName,
  headerRow,
}) => {
  const formData = buildExcelFillFormData({
    schoolYearId,
    file,
    sheetName,
    headerRow,
  });

  const response = await api.post(`${BASE_URL}/preview`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const checkExcelFill = async (payload) => {
  const formData = buildExcelFillFormData(payload);

  const response = await api.post(`${BASE_URL}/check`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const generateExcelFill = async (payload) => {
  const formData = buildExcelFillFormData(payload);

  const response = await api.post(`${BASE_URL}/generate`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type:
      response.headers["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "power-trajecten-aangevuld.xlsx";
  document.body.appendChild(link);
  link.click();
  link.remove();

  window.URL.revokeObjectURL(url);

  return {
    filename: "power-trajecten-aangevuld.xlsx",
  };
};

const excelFillService = {
  previewExcelFill,
  checkExcelFill,
  generateExcelFill,
};

export default excelFillService;
